import {ImageLink} from "./image_link";
import style from "../pages/front_page_styles.module.css";
import React, {useEffect, useRef, useState} from "react";
import {Images} from "../AssetReferences";
import {AdditionalElementSounds} from "../pages/front_page_data";
import {FadeTo} from "./fadeTo";
import {Fader} from "./fader";
import {OPACITY_DIMMED, OPACITY_FULL} from "../pages/front_page";


export const ATTACK_TIME = 80;
export const RELEASE_TIME = 3000;

export function AdditionalElement({
                                      id,
                                      image_url,
                                      className,
                                      highlighted,
                                      onClick,
                                      onHoverStart,
                                      onHoverEnd,
                                      position,
                                      x_position,
                                      y_position,
                                      canvas_reference_image,
                                      detect_underfoot,
                                      refresh_canvas_image
                                  }) {


    const audioRef = useRef(null)
    const fader = useRef(new Fader());
    const [isPlaying, setIsPlaying] = useState(false);


    useEffect(() => {
        // console.log("additional element mount")
    }, []);

    function PlaySound() {
        // console.log("PlaySound")

        const audio = audioRef.current;

        if (!isPlaying) audio.currentTime = 0;

        audio.play();
        setIsPlaying(true)

        fader.current.DoFade(audio, -3, isPlaying ? ATTACK_TIME : 0);
    }

    function StopSound() {
        if (!isPlaying) return;

        const audio = audioRef.current;

        fader.current.DoFade(audio, -70, RELEASE_TIME,
            () => {
                setIsPlaying(false)
                return audio.pause();
            })
    }


    return (
        <div style={{opacity: highlighted ? highlighted.id === id ? OPACITY_FULL : OPACITY_DIMMED : OPACITY_FULL}}>
            
            
            <audio ref={audioRef} src={AdditionalElementSounds.Get(id)} loop={true}/>
            <ImageLink
                id={id}
                image_url={image_url}
                className={className}
                onClick={onClick}
                onMouseDown={PlaySound}
                onMouseUp={StopSound}
                onHoverStart={onHoverStart}
                onHoverEnd={() => {
                    StopSound();
                    onHoverEnd?.()
                }}
                position={position}
                x_position={x_position}
                y_position={y_position}
                detect_underfoot={detect_underfoot}
                refresh_canvas_image={refresh_canvas_image}
                canvas_reference_image={canvas_reference_image}
            />

        </div>
    )
}